// Hook into Shopify's theme section system if it exists
(function() {
  // Store a reference to when the script was loaded
  const SCRIPT_LOADED_AT = new Date().getTime();
  
  // Helper function to check if DOM is ready
  function isDomReady() {
    return document.readyState === 'complete' || document.readyState === 'interactive';
  }
  
  // Function to handle errors with meaningful messages
  function handleError(error, context) {
    console.error(`Featured Blog Slider Error (${context}):`, error);
  }

  // Add the P object to match the theme's structure exactly
  const P = {
    isExist: (e) => null != e && void 0 !== e,
    getWidthBrowser: function () {
      let e;
      return (
        "number" == typeof window.innerWidth
          ? (e = window.innerWidth)
          : document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight)
          ? (e = document.documentElement.clientWidth)
          : document.body && (document.body.clientWidth || document.body.clientHeight) && (e = document.body.clientWidth),
        e
      );
    }
  };

  // Helper to check if theme.slider is available
  function isThemeSliderReady() {
    return typeof theme !== 'undefined' && typeof theme.slider === 'function';
  }
  
  // Function to poll until theme.slider is available
  function waitForThemeSlider(callback, maxAttempts = 10) {
    let attempts = 0;
    
    function checkThemeSlider() {
      if (isThemeSliderReady()) {
        callback();
        return;
      }
      
      attempts++;
      if (attempts >= maxAttempts) {
        console.warn('Featured Blog Slider: theme.slider not available after multiple attempts');
        // If theme.slider is never available, try to use a fallback method
        tryFallbackInitialization();
        return;
      }
      
      // Try again in 300ms
      setTimeout(checkThemeSlider, 300);
    }
    
    checkThemeSlider();
  }
  
  // Fallback initialization using native features
  function tryFallbackInitialization() {
    try {
      const blogSections = document.querySelectorAll('[data-section-type="featured-blog"]');
      
      blogSections.forEach(section => {
        // If slider isn't available, at least make sure content is visible
        const slideElement = section.querySelector('.slide_ui-element');
        if (slideElement) {
          // Make sure the slide items are visible
          Array.from(slideElement.children).forEach(child => {
            child.style.display = 'block';
            child.style.float = 'left';
            child.style.marginBottom = '20px';
          });
          
          // Add a clearfix to the container
          const clearfix = document.createElement('div');
          clearfix.style.clear = 'both';
          slideElement.appendChild(clearfix);
          
        }
      });
    } catch (error) {
      handleError(error, 'fallbackInitialization');
    }
  }
  
  /**
   * Check if arrows should be hidden based on slide count and visible items
   * @param {Object} info - Slider info object
   * @return {Boolean} - True if arrows should be hidden
   */
  function shouldHideArrows(info) {
    // Hide arrows if there are fewer or equal slides than visible items
    return info && info.slideCount <= info.items;
  }
  
  // Function to initialize the slider using the theme's existing slider functionality
  function initBlogSlider(container) {
    try {
      
      // Get the section element
      const section = container || document.querySelector('[data-section-type="featured-blog"]');
      if (!section) {
        console.warn('Featured blog section not found');
        return;
      }
      
      // Make sure we're not initializing twice
      if (section.dataset.sliderInitialized === 'true') {
        return;
      }
      
      // Find slider elements
      const slideConfig = section.querySelector('input[name="sectionSlideConfig"]');
      const slideElement = section.querySelector('.slide_ui-element');
      
      if (!slideConfig || !slideElement) {
        console.warn('Slider configuration or elements not found');
        return;
      }
      
      // Check if slide element has children
      if (!slideElement.children || slideElement.children.length === 0) {
        console.warn('Slider element has no children to slide');
        return;
      }
      
      // Mark as initialized to prevent duplicate initialization
      section.dataset.sliderInitialized = 'true';
      
      // Process slider configuration - Keep the exact format as in home.js
      const nav = slideConfig.getAttribute("data-nav") === "true";
      const dots = slideConfig.getAttribute("data-dot") === "true";
      const loop = slideConfig.getAttribute("data-loop") === "true"; 
      
      // Parse slider configuration
      let items = slideConfig.getAttribute("data-items") ? 
                 slideConfig.getAttribute("data-items").split(",") : 
                 ['1', '1', '1', '1', '1', '1'];
      
      let gutters = slideConfig.getAttribute("data-gutters") ? 
                   slideConfig.getAttribute("data-gutters").replace(/[^\d.,]/g, "").split(",") : 
                   ['0', '0', '0', '0', '0', '0'];
      
      const itemClass = slideConfig.getAttribute("data-item-class") || '';
      const sectionType = section.getAttribute("data-section-type") || "";
      
      // Create responsive config exactly as in home.js
      const responsive = {
        0: { items: +items[5] || +items[0], gutter: +gutters[5] || +gutters[0], center: false },
        375: { items: +items[4] || +items[0], gutter: +gutters[4] || +gutters[0], center: false },
        576: { items: +items[3] || +items[0], gutter: +gutters[3] || +gutters[0], center: false },
        768: { items: +items[2] || +items[0], gutter: +gutters[2] || +gutters[0], center: false },
        992: { items: +items[1] || +items[0], gutter: +gutters[1] || +gutters[0], center: false },
        1200: { items: +items[0] || +items[0], gutter: +gutters[0] || +gutters[0], center: false }
      };
      
      // Apply styles to match theme approach
      if (slideElement) {
        slideElement.classList.remove("row", "d-grid");
      }
      
      // Apply item class if specified
      if (itemClass) {
        for (let i = 0; i < slideElement.children.length; i++) {
          slideElement.children[i].className = itemClass;
        }
      }
      
      // Create a wrapper for controls if needed
      const wrapper = slideElement.closest('[data-slide-wrapper]');
      
      // First, clean up any existing controls to prevent duplicates
      const existingControls = wrapper.querySelectorAll('.slide_ui-controls-wrapper, .slide_ui-controls, .tns-controls');
      existingControls.forEach(control => {
        control.remove();
      });
      
      // Create a fresh controls wrapper
      const controlsWrapperDiv = document.createElement('div');
      controlsWrapperDiv.className = 'slide_ui-controls-wrapper';
      wrapper.appendChild(controlsWrapperDiv);
      
      // Only create navigation arrows if slide_nav is true
      let customControlsContainer;
      if (nav) {
        // Create custom navigation controls
        customControlsContainer = document.createElement('div');
        customControlsContainer.className = 'slide_ui-controls slide_ui-controls--nav custom-added-controls';
        customControlsContainer.setAttribute('aria-label', 'Carousel Navigation');
        customControlsContainer.setAttribute('tabindex', '0');
        
        // Create prev button
        const prevButton = document.createElement('button');
        prevButton.className = 'slide_ui-btn-prev';
        prevButton.setAttribute('data-controls', 'prev');
        prevButton.innerHTML = '<svg width="11" height="21" viewBox="0 0 11 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.85 10.373L11 17.999L7.638 20.418L0.257999 10.209L7.638 0L11 2.419L4.85 10.373Z" fill="white"></path></svg>';
        
        // Create next button
        const nextButton = document.createElement('button');
        nextButton.className = 'slide_ui-btn-next';
        nextButton.setAttribute('data-controls', 'next');
        nextButton.innerHTML = '<svg width="11" height="21" viewBox="0 0 11 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.15 10.373L0 17.999L3.362 20.418L10.742 10.209L3.362 0L0 2.419L6.15 10.373Z" fill="white"></path></svg>';
        
        // Add button disabled style
        const style = document.createElement('style');
        style.textContent = `
          .slide_ui-btn-prev.disabled,
          .slide_ui-btn-next.disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }
          .slide_ui-controls--nav.hidden {
            display: none;
          }
        `;
        document.head.appendChild(style);
        
        // Add buttons to container
        customControlsContainer.appendChild(prevButton);
        customControlsContainer.appendChild(nextButton);
        
        // Add custom controls to wrapper
        controlsWrapperDiv.appendChild(customControlsContainer);
      }
      
      // Let Tiny Slider create the slider (but don't use its controls)
      const sliderOptions = {
        container: slideElement,
        items: items[5] || 1,
        gutter: gutters[5] || 0,
        slideBy: 'page', // Changed to 'page' to match the number of visible items, like the dots do
        startIndex: 0,
        loop: loop,
        speed: 300,
        edgePadding: 0,
        mouseDrag: true,
        swipeAngle: 30,
        autoplayButtonOutput: false,
        autoplay: false,
        autoplayTimeout: 5000,
        animateIn: "tns-fadeIn",
        animateOut: "tns-fadeOut",
        controls: false, // No need for Tiny Slider controls, we're using our own
        controlsPosition: "bottom",
        nav: dots,
        navPosition: "bottom",
        responsive: responsive,
        preventActionWhenRunning: false,
        preventScrollOnTouch: false,
        textDirection: document.body.dir,
        onInit: function() {
          
          // Make sure we only have our custom controls if arrows are enabled
          if (nav) {
            // Remove any auto-generated controls from Tiny Slider
            const autoGenControls = section.querySelectorAll('.tns-controls');
            autoGenControls.forEach(control => {
              control.remove();
            });
            
            // Check if multiple control sets exist and keep only our custom one
            const allControls = section.querySelectorAll('.slide_ui-controls--nav');
            if (allControls.length > 1) {
              allControls.forEach(control => {
                // Keep only our custom controls
                if (!control.classList.contains('custom-added-controls')) {
                  control.remove();
                }
              });
            }
            
            // NOTE: We will check if arrows should be hidden AFTER the slider is fully initialized
          } else {
            // If arrows are disabled, remove any that might have been created
            const allControlsNavs = section.querySelectorAll('.slide_ui-controls--nav');
            allControlsNavs.forEach(control => {
              control.remove();
            });
          }
          
          // Move the dots if they exist and are enabled
          if (dots) {
            const navDots = section.querySelector('.tns-nav');
            if (navDots) {
              // Add a special class to identify our customized dots
              navDots.classList.add('custom-handled-dots');
              controlsWrapperDiv.appendChild(navDots);
              
              // NOTE: We will check if dots should be hidden AFTER the slider is fully initialized
              
              // For better synchronization - ensure dot clicks update our custom arrows state
              if (nav && !loop) {
                const dotButtons = navDots.querySelectorAll('button');
                if (dotButtons.length > 0) {
                  dotButtons.forEach((dot, index) => {
                    dot.addEventListener('click', function() {
                      // Find our arrows
                      const prevBtn = section.querySelector('.slide_ui-btn-prev');
                      const nextBtn = section.querySelector('.slide_ui-btn-next');
                      
                      if (prevBtn && nextBtn) {
                        // Update arrow states based on the clicked dot's index
                        if (index === 0) {
                          prevBtn.classList.add('disabled');
                        } else {
                          prevBtn.classList.remove('disabled');
                        }
                        
                        if (index >= dotButtons.length - 1) {
                          nextBtn.classList.add('disabled');
                        } else {
                          nextBtn.classList.remove('disabled');
                        }
                      }
                    });
                  });
                }
              }
            }
          }
          
          // Add outer class for styling
          const outer = section.querySelector('.tns-outer');
          if (outer) {
            outer.classList.add('slide_ui-outer');
          }
        }
      };
      
      
      try {
        // Let theme.slider create the slider
        const sliderInstance = theme.slider(sliderOptions);
        if (sliderInstance) {
          slideElement.tnsSlider = sliderInstance;
          
          // Now that sliderInstance exists, check slide count and hide controls if needed
          const info = sliderInstance.getInfo ? sliderInstance.getInfo() : null;
          
          // Hide navigation if not enough slides
          if (nav && info && shouldHideArrows(info)) {
            const navControls = section.querySelector('.slide_ui-controls--nav');
            if (navControls) {
              navControls.classList.add('hidden');
            }
          }
          
          // Hide dots if not enough slides
          if (dots && info && info.slideCount <= info.items) {
            const navDots = section.querySelector('.tns-nav');
            if (navDots) {
              navDots.style.display = 'none';
            }
          }
          
          // Only add event listeners if we created the arrows (nav === true)
          if (nav) {
            // Find our buttons
            const prevButton = controlsWrapperDiv.querySelector('.slide_ui-btn-prev');
            const nextButton = controlsWrapperDiv.querySelector('.slide_ui-btn-next');
            
            if (prevButton && nextButton) {
              // Add click events that use the proper slider API methods
              // These methods ensure the dots will update automatically
              prevButton.addEventListener('click', function() {
                if (sliderInstance && typeof sliderInstance === 'object') {
                  // Using the proper Tiny Slider API method - 'page' navigation to match dots
                  if (typeof sliderInstance.goTo === 'function') {
                    sliderInstance.goTo('prev');
                  } else if (sliderInstance.slider && typeof sliderInstance.slider.goTo === 'function') {
                    sliderInstance.slider.goTo('prev');
                  } else if (typeof sliderInstance.prev === 'function') {
                    sliderInstance.prev();
                  } else {
                    // Direct DOM access fallback if all else fails
                    const info = sliderInstance.getInfo ? sliderInstance.getInfo() : null;
                    if (info) {
                      // Calculate page size based on visible items (matching dot navigation)
                      const pageSize = info.items || 1;
                      const index = info.index - pageSize;
                      sliderInstance.goTo(index >= 0 ? index : 0);
                    }
                  }
                }
              });
              
              nextButton.addEventListener('click', function() {
                if (sliderInstance && typeof sliderInstance === 'object') {
                  // Using the proper Tiny Slider API method - 'page' navigation to match dots
                  if (typeof sliderInstance.goTo === 'function') {
                    sliderInstance.goTo('next');
                  } else if (sliderInstance.slider && typeof sliderInstance.slider.goTo === 'function') {
                    sliderInstance.slider.goTo('next');
                  } else if (typeof sliderInstance.next === 'function') {
                    sliderInstance.next();
                  } else {
                    // Direct DOM access fallback if all else fails
                    const info = sliderInstance.getInfo ? sliderInstance.getInfo() : null;
                    if (info) {
                      // Calculate page size based on visible items (matching dot navigation)
                      const pageSize = info.items || 1;
                      const index = info.index + pageSize;
                      sliderInstance.goTo(Math.min(index, info.slideCount - 1));
                    }
                  }
                }
              });
              
              // Listen to slider events to sync arrow states
              if (sliderInstance.events) {
                sliderInstance.events.on('indexChanged', function() {
                  const info = sliderInstance.getInfo ? sliderInstance.getInfo() : null;
                  if (info) {
                    // Check if we need to hide arrows completely
                    const navControls = section.querySelector('.slide_ui-controls--nav');
                    if (navControls) {
                      if (shouldHideArrows(info)) {
                        navControls.classList.add('hidden');
                      } else {
                        navControls.classList.remove('hidden');
                        
                        // Only update disable states if we're showing arrows and not looping
                        if (!loop) {
                          // Update prev button state
                          if (info.index <= 0) {
                            prevButton.classList.add('disabled');
                          } else {
                            prevButton.classList.remove('disabled');
                          }
                          
                          // Update next button state
                          if (info.index >= info.slideCount - info.items) {
                            nextButton.classList.add('disabled');
                          } else {
                            nextButton.classList.remove('disabled');
                          }
                        }
                      }
                    }
                  }
                });
                
                // Initialize slider with the correct arrow states
                const info = sliderInstance.getInfo ? sliderInstance.getInfo() : null;
                if (info) {
                  // Hide arrows completely if not enough slides
                  const navControls = section.querySelector('.slide_ui-controls--nav');
                  if (navControls && shouldHideArrows(info)) {
                    navControls.classList.add('hidden');
                  } else if (!loop && info.index <= 0 && prevButton) {
                    // If showing arrows and not enough slides to start disabled
                    prevButton.classList.add('disabled');
                  }
                }
              }
            }
          }
          
          return sliderInstance;
        }
      } catch (error) {
        handleError(error, 'theme.slider call');
        tryFallbackInitialization();
      }
    } catch (error) {
      handleError(error, 'initBlogSlider');
      tryFallbackInitialization();
    }
    return null;
  }
  
  // Main initialization function
  function init() {
    try {
      const blogSections = document.querySelectorAll('[data-section-type="featured-blog"]');
      
      if (blogSections.length === 0) {
        return;
      }
      
      // Wait for theme.slider to be available before initializing
      waitForThemeSlider(function() {
        blogSections.forEach(section => {
          initBlogSlider(section);
        });
      });
    } catch (error) {
      handleError(error, 'init');
      tryFallbackInitialization();
    }
  }
  
  // Expose the initialization function globally
  window.initFeaturedBlogSlider = function(container) {
    if (isThemeSliderReady()) {
      initBlogSlider(container);
    } else {
      waitForThemeSlider(function() {
        initBlogSlider(container);
      });
    }
  };
  
  // Start initialization when DOM is ready
  if (isDomReady()) {
    setTimeout(init, 100); // Small delay to ensure theme.js is fully loaded
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(init, 100);
    });
  }
  
  // Handle Shopify section events
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.section && event.detail.section.type === 'featured-blog') {
      // Reset initialization flag to allow re-initialization
      if (event.detail.section.container) {
        event.detail.section.container.dataset.sliderInitialized = 'false';
      }
      // Wait a moment for any needed resources to load
      setTimeout(() => {
        window.initFeaturedBlogSlider(event.detail.section.container);
      }, 300);
    }
  });
  
  // Register with Shopify's section system if available
  if (typeof Shopify !== 'undefined' && 
      typeof Shopify.theme !== 'undefined' && 
      typeof Shopify.theme.sections !== 'undefined') {
    
    try {
      // Register the section if not already registered
      if (!Shopify.theme.sections.registered['featured-blog']) {
        
        Shopify.theme.sections.register('featured-blog', {
          onLoad: function() {
            // Give the DOM time to fully initialize
            setTimeout(() => {
              window.initFeaturedBlogSlider(this.container);
            }, 100);
          },
          onSelect: function() {
            const sliderElement = this.container.querySelector('.slide_ui-element');
            if (sliderElement && sliderElement.tnsSlider) {
              sliderElement.tnsSlider.refresh();
            }
          }
        });
      }
    } catch (error) {
      handleError(error, 'section registration');
    }
  }
})();